import React, { useCallback, useEffect, useState } from 'react';
import { Typography, Avatar, ListItemText, ListItemButton, ListItemAvatar } from '@mui/material';
import PropTypes from 'prop-types';
import io from 'socket.io-client';

import Iconify from '../../../components/iconify';
import axiosInstance from '../../../api';
import SERVER_API_URL from '../../../config';

export default function PersonalSideBar({ userQuery, handleSearch, targetId, myId }) {
  const [avatarUrls, setAvatarUrls] = useState({});
  const [userList, setUserList] = useState([]);
  const [filteredUser, setFilteredUser] = useState([]);
  const [socket, setSocket] = useState(null);

  const getUserAvatars = useCallback(
    (filteredUser) => {
      if (Array.isArray(filteredUser)) {
        filteredUser.forEach((user) => {
          if (!avatarUrls[user.id]) {
            getAvatarById(user.id)
              .then((url) => {
                setAvatarUrls((prevUrls) => ({
                  ...prevUrls,
                  [user.id]: url,
                }));
              })
              .catch((error) => {
                console.error('Error fetching avatar::a', error);
              });
          }
        });
      }
    },
    [avatarUrls]
  );

  useEffect(() => {
    getUserAvatars(filteredUser);
  }, [filteredUser, getUserAvatars]);

  const getAvatarById = async (id) => {
    try {
      const response = await axiosInstance.get(`${SERVER_API_URL}/avatar/getAvatarById/${id}`, {
        responseType: 'blob',
      });
      if (response.status === 200) {
        return URL.createObjectURL(response.data);
      }
      throw new Error('Failed to fetch avatar: new');
    } catch (error) {
      console.error('Error fetching avatar: new', error);
      throw error;
    }
  };

  useEffect(() => {
    const getAllUser = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/user/findChatSideBar/${myId}`);

        if (response.status === 200) {
          const rawUser = [];
          response.data.forEach((person) => {
            if (person.username && person.email) {
              rawUser.push(person);
              if (myId === person.id) {
                person.fullName = 'የግል ሳጥን';
              }
            }
          });
          setUserList(rawUser);
          setFilteredUser(rawUser);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getAllUser();
  }, [myId]);

  useEffect(() => {
    const allUser = userList;
    setFilteredUser(
      userQuery ? allUser.filter((user) => user.fullName.toLowerCase().includes(userQuery.toLowerCase())) : allUser
    );
  }, [userQuery, userList]);

  useEffect(() => {
    const newSocket = io(`${SERVER_API_URL}`, { transports: ['websocket'] });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on('onMessage', (newMessage) => {
        if (newMessage.target.userId === myId && targetId !== newMessage.sender.id) {
          // console.log('doing::', newMessage);
          setUserList((prevUsers) =>
            prevUsers.map((user) =>
              user.id === newMessage.sender.id ? { ...user, unreadCounter: user.unreadCounter + 1 } : user
            )
          );
        }
      });
    }

    return () => {
      if (socket) {
        socket.off('onMessage');
      }
    };
  }, [socket, targetId, myId]);

  const handleRead = (userId) => {
    setUserList((prevUsers) => prevUsers.map((user) => (user.id === userId ? { ...user, unreadCounter: 0 } : user)));
  };

  return (
    filteredUser &&
    filteredUser.map((user) => (
      <ListItemButton
        key={user.id}
        onClick={() => {
          handleSearch(user.id, user.fullName);
          handleRead(user.id);
        }}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(user.id === targetId && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        {myId === user.id && (
          <>
            <ListItemAvatar>
              <Avatar>
                <Iconify icon="twemoji:bookmark" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="የግል ሳጥን" />
          </>
        )}

        {myId !== user.id && (
          <>
            <ListItemAvatar>
              <Avatar src={avatarUrls[user.id]} alt={`${user.fullName}'s avatar`} />
            </ListItemAvatar>
            <ListItemText
              primary={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{user.fullName}</span>
                  {user?.unreadCounter > 0 && (
                    <span style={{ color: '#2065d1', backgroundColor: '#cde7e9', borderRadius: "50%", padding: '2px 6px', textAlign: 'center' }}>
                      {user.unreadCounter}
                    </span>
                  )}
                </div>
              }
              secondary={
                <Typography
                  variant="caption"
                  sx={{
                    mt: 0.5,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.disabled',
                  }}
                >
                  <Iconify sx={{ color: user.category.color }} icon="ic:twotone-family-restroom" /> - {user.role.name}
                </Typography>
              }
            />
          </>
        )}
      </ListItemButton>
    ))
  );
}

PersonalSideBar.propTypes = {
  userQuery: PropTypes.string,
  handleSearch: PropTypes.func,
  targetId: PropTypes.string,
  userId: PropTypes.string,
};
